fx.ns("desktop.poster", class PhotoChoices extends desktop.common.photoimport.PhotoChoices 
{
    constructor()
    {
        super({ file: true, albums: false});

        this.showNext = false;
        this.containerHeight = 540;
    }

    create()
    {
        // Google is disabled for AI effects
        if (this.data.hasFilteredPhoto)
            this.options.google = false;

        if (this.data.hasFilteredPhoto)
            this.options.file = false;

        super.create();

        if (this.data.hasFilteredPhoto)
        {
            this.title.text = "Sélectionnez une photo depuis :";
            this.container.addChild(new fx.components.Text({ className: "bottom-text", text: fx.assets.warningRoundIcon.render() + fx.text("De préférence une photo de portrait avec des visages visibles") }), { width: "auto", height: "auto", bottom: 0, left: "center" });

            this.photoComponent = this.data.creation.filteredPhoto;
        }
    }

    onReady() {
        super.onReady();

        this.on("photo-extracted", this._onPhotoExtracted, fx.service("MediasUploader"));
        this.on("photo-extracted-started", this._onPhotoExtractedStarted, fx.service("MediasUploader"));
        this.on("photo-extracted-finished", this._onPhotoExtractedFinished, fx.service("MediasUploader"));
        // no -finished on GoogleService : the validation moves on now, not the end of the fetch
        this.on("photo-extracted", this._onPhotoExtracted, fx.service("GoogleService"));
    }

    _onPhotoExtractedStarted() {
        this.popup(new shared.popups.ExtractingPhotosPopup());
    }

    _onPhotoExtracted(e) {
    }

    _onPhotoExtractedFinished(e) {
        if (fx.get("mode") == "creating")
        {
            if (this.data.hasFilteredPhoto)
                this.data.event("step-RemotePhotoEffectWaiting");
            else
                this.data.event("show-editor");
        }
        else
        {
            if (this.data.hasFilteredPhoto)
                this.data.event("filtering-photo");
            else
                this.data.event("show-editor");
        }
    }

    _onPdfSelected(event)
    {
        this._pdfToUpload = event.detail;
        this.data.event("show-editor");
    }

    destroy() {
        var files = this._pdfToUpload;
        this._pdfToUpload = null;

        super.destroy();

        if (files)
            setTimeout(function () { fx.service("PdfUploader").upload(files); }, 0);
    }

    close() {

        if (!this.data) return;
        
        if (fx.get("mode") == "creating")
        {
            if (this.data.hasFilteredPhoto)
                this.data.event("step-RemotePhotoEffectWaiting");
            else
                this.data.event("show-editor");
        }
        else
            this.data.event("show-editor");
    }

});